import http from "./main";

export default {
  reportInRange: async (dateRange) => {
    return await http.get(
      `doctors/reports?startDate=${dateRange[0]}&endDate=${dateRange[1]}`
    );
  },
};
